interface Props {
  percent: number | null | undefined;
}

export function JobProgressBar({ percent }: Props) {
  return (
    <div className="progress progress-striped active">
      <div
        className="progress-bar"
        role="progressbar"
        style={{ width: `${percent ?? 0}%` }}
      />
    </div>
  );
}
